import React from 'react';
import { Button } from '../ui/Button';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="bg-charcoal text-cream py-24 px-6 relative" data-id="element-133">
      <div className="max-w-4xl mx-auto text-center" data-id="element-134">
        <FadeIn data-id="element-135">
          <div className="inline-block bg-copper/20 text-copper px-4 py-1 rounded-full text-sm font-semibold tracking-wider uppercase mb-8" data-id="element-136">
            Oferta Especial de Lanzamiento
          </div>

          <h2 className="text-4xl md:text-5xl font-serif text-cream mb-6" data-id="element-137">
            Recupera el control de tu cuerpo
          </h2>

          <p className="text-xl text-cream/80 mb-12 max-w-2xl mx-auto" data-id="element-138">
            Obtén el protocolo completo RESET 21 hoy mismo por una inversión
            única. Menos de lo que cuesta una cena fuera de casa.
          </p>

          <div className="bg-white/5 border border-copper/30 p-10 md:p-14 rounded-sm max-w-2xl mx-auto backdrop-blur-sm" data-id="element-139">
            <div className="inline-block px-4 py-1 rounded-full text-sm font-bold tracking-wider uppercase mb-6 text-[#C4966A] bg-[#C4966A23]" data-id="element-140">
              24% de descuento
            </div>
            <p className="text-cream/60 uppercase tracking-widest text-sm mb-4" data-id="element-141">
              Precio Especial
            </p>
            <div className="flex justify-center items-center gap-4 mb-2" data-id="element-142">
              <span className="text-2xl font-serif text-cream/40 line-through" data-id="element-143">
                $27.00
              </span>
            </div>
            <div className="flex justify-center items-start gap-1 mb-8" data-id="element-144">
              <span className="text-3xl font-serif text-copper mt-2" data-id="element-145">$</span>
              <span className="text-7xl font-serif text-copper font-bold" data-id="element-146">
                6
              </span>
              <span className="text-4xl font-serif text-copper font-bold mt-2" data-id="element-147">
                .48
              </span>
              <span className="text-xl text-copper mt-8 ml-1" data-id="element-148">USD</span>
            </div>

            <Button className="w-full text-xl py-6 mb-6 shadow-[0_0_40px_rgba(196,149,106,0.3)]" onClick={() => window.open('https://aeduclub.com/cart/47740137799898:1', '_blank')} data-id="element-149">
              ¡QUIERO MI RESET 21 AHORA!
            </Button>

            <div className="flex items-center justify-center gap-2 text-cream/50 text-sm" data-id="element-150">
              <ShieldCheck className="w-4 h-4" data-id="element-151" />
              <span data-id="element-152">
                Acceso inmediato tras la compra. Pago seguro y encriptado.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}